var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficInfoNar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "traffic_x5F_info_x5F_nar",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "traffic_x5F_info_x5F_nar_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "triangle_x5F_yellow",
    style: {
      fill: "#D9A32A"
    },
    d: "M44.586,22.586L25.414,3.414c-0.781-0.781-2.047-0.781-2.828,0 L3.414,22.586c-0.781,0.781-0.781,2.047,0,2.828l19.172,19.172c0.781,0.781,2.047,0.781,2.828,0l19.172-19.172 C45.367,24.633,45.367,23.367,44.586,22.586z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "triangle_x5F_black",
    d: "M24,42.792c-0.384,0-0.768-0.146-1.061-0.438L5.646,25.061c-0.585-0.585-0.585-1.536,0-2.121 L22.939,5.646c0.585-0.585,1.536-0.585,2.121,0l17.293,17.293c0.585,0.585,0.585,1.536,0,2.121L25.061,42.354 C24.768,42.646,24.384,42.792,24,42.792z M7.414,24L24,40.586L40.586,24L24,7.414L7.414,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "car_x5F_front",
    d: "M31.333,24l-0.74-1.109C30.223,22.334,29.598,22,28.93,22H25.07c-0.669,0-1.293,0.334-1.664,0.891 L22.667,24H22v1v2v1v2h2v-2h6v2h2v-2v-1v-2v-1H31.333z M24.238,23.445C24.424,23.166,24.735,23,25.07,23h3.859 c0.335,0,0.646,0.166,0.832,0.445L30.798,25h-7.596L24.238,23.445z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "car_x5F_back",
    d: "M25.07,20H27v-2v-1h-0.667l-0.74-1.109C25.223,15.334,24.598,15,23.93,15H20.07 c-0.669,0-1.293,0.334-1.664,0.891L17.667,17H17v1v2v1v2h2v-2h3.428C23.149,20.364,24.083,20,25.07,20z M18.202,18l1.036-1.555 C19.424,16.166,19.735,16,20.07,16h3.859c0.335,0,0.646,0.166,0.832,0.445L25.798,18H18.202z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficInfoNar);
export default __webpack_public_path__ + "static/media/icon-traffic_info_nar.62da3abc0ccf6e61dea8cff460f336b7.svg";
export { ForwardRef as ReactComponent };